import { render, staticRenderFns } from "./natural-device.vue?vue&type=template&id=508f4ba3&scoped=true"
import script from "./natural-device.vue?vue&type=script&lang=js"
export * from "./natural-device.vue?vue&type=script&lang=js"
import style0 from "./natural-device.vue?vue&type=style&index=0&id=508f4ba3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f4ba3",
  null
  
)

export default component.exports